import React from 'react';

import { FeaturesBonusProgram } from '@travel/icons/features';
import useDialogHandler from '@travel/traveler-core/hooks/useDialogHandler';

import styles from './bonusProgram.module.scss';

import type { HeaderLabels } from '../../types';

const BonusProgram = ({
  labels,
  isPC = true,
}: {
  labels: HeaderLabels['bonusTooltip'];
  isPC?: boolean;
}) => {
  const { isOpen: showPopup, onOpen, onClose, onToggle } = useDialogHandler(false);

  const handleInteraction = () => {
    if (!isPC) {
      onToggle();
    }
  };

  const handleMouseEnter = () => {
    if (isPC) {
      onOpen();
    }
  };

  const handleMouseLeave = () => {
    if (isPC) {
      onClose();
    }
  };

  return (
    <div className={styles.bonusProgram}>
      <FeaturesBonusProgram
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        onClick={handleInteraction}
        data-testid="providerCommonHeader-bonusProgram-icon"
      />
      {showPopup && (
        <div
          className={styles.popupContainer}
          data-testid="providerCommonHeader-bonusProgram-popup"
        >
          <div className={styles.popupTriangle}></div>
          <p className={styles.popupContent}>
            {labels.start}
            <p>{labels.end}</p>
          </p>
        </div>
      )}
    </div>
  );
};

export default BonusProgram;
